import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls } from "../../shared/seo/links";
import "./lawyers.css";

// Every governorate's listing, as plain links (also what crawlers follow).
export default function GovernorateLinks({ lang, current }) {
  const { t } = useTranslation();
  return (
    <div className="avc-sidebar-card avc-gov-links">
      <h2 className="avc-sidebar-card__title">{t("lawyers_by_governorate")}</h2>
      <ul>
        {urls.GOVERNORATES.map((gov) => (
          <li key={gov.key}>
            <PathLink
              to={urls.lawyersPath(lang, { governorate: gov })}
              className={current && current.key === gov.key ? "is-current" : undefined}
              aria-current={current && current.key === gov.key ? "page" : undefined}
            >
              {urls.governorateName(gov, lang)}
            </PathLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
